import { createStyles, makeStyles } from '@material-ui/styles';
export var useStyles = makeStyles(function (theme) {
    var rootBorderColor = theme.palette.type === 'light' ? theme.palette.border.dark : theme.palette.border.main;
    var rootIconColor = theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.secondary;
    var selectedBackgroundColor = theme.palette.type === 'light' ? theme.palette.brand.light : theme.palette.brandAlt.main;
    var selectedIconColor = theme.palette.type === 'light' ? theme.palette.brand.main : theme.palette.border.dark;
    return createStyles({
        root: {
            backgroundColor: theme.palette.background.b1,
            minWidth: '38px',
            minHeight: '38px',
            padding: '4px',
            border: function (_a) {
                var variant = _a.variant;
                return variant === 'standalone' ? 'transparent' : "1px solid ".concat(rootBorderColor);
            },
            color: rootIconColor,
            '&:hover': {
                backgroundColor: theme.palette.background.b3,
                border: "1px solid".concat(theme.palette.background.b8),
            },
            '&[disabled]': {
                border: function (_a) {
                    var variant = _a.variant;
                    return variant === 'standalone' ? 'transparent' : "1px solid ".concat(theme.palette.action.disabled);
                },
            },
        },
        selected: {
            '&$root': {
                backgroundColor: selectedBackgroundColor,
                border: "1px solid".concat(theme.palette.brand.main),
                '&:focus, &:hover': {
                    backgroundColor: selectedBackgroundColor,
                },
            },
            boxSizing: 'border-box',
            width: '37px',
            height: '37px',
            '& svg': {
                color: selectedIconColor,
            },
        },
    });
});
//# sourceMappingURL=ToogleButton.styles.js.map